// extracted by mini-css-extract-plugin
export var DropBox = "DropBox-module--DropBox--c+S24";
export var button = "DropBox-module--button--qAnpT";
export var arrow = "DropBox-module--arrow--uEObA";
export var click = "DropBox-module--click--jbbQi";
export var fold = "DropBox-module--fold--vsQNT";